import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'languageCode',
    standalone: false
})
export class LanguageCodePipe implements PipeTransform {
    transform(countryLanguageCode: string | null): string {
        return countryLanguageCode ? countryLanguageCode.slice(0, 2).toLowerCase() : '';
    }
}
